import React from 'react';
import {Box, Input, Pressable, SearchIcon, FormControl} from 'native-base';
import {defaultProps} from '../../constants';
import {message as t} from '../../../../utils/messages';

interface InputProps {
  onChange?: (value: string) => void;
  value?: string | null;
  readonly?: boolean;
  onPress?: () => void;
  defaultValue?: string;
  label?: string;
}

const SearchInput = (props: InputProps) => {
  const {
    onChange,
    readonly,
    onPress: launchOnPressIn,
    defaultValue,
    label,
  } = props;

  const handleOnChangeText = (text: string) => {
    if (onChange) {
      onChange(text);
    }
  };

  const handleOnPressIn = () => {
    if (launchOnPressIn) {
      launchOnPressIn();
    }
  };

  return (
    <Box width="100%" marginBottom={5}>
      <FormControl>
        {label && <FormControl.Label>{t(label)}</FormControl.Label>}

        <Input
          {...defaultProps}
          key={'search-input'}
          InputRightElement={
            <Pressable onPressIn={handleOnPressIn}>
              <SearchIcon color="blue.500" size="6" mr={3} />
            </Pressable>
          }
          onChangeText={text => handleOnChangeText(text)}
          isReadOnly={readonly ?? false}
          onPressIn={handleOnPressIn}
          defaultValue={defaultValue}
        />
      </FormControl>
    </Box>
  );
};

export default SearchInput;
